import { render, staticRenderFns } from "./TextList.vue?vue&type=template&id=d4d54af6&scoped=true&"
import script from "./TextList.vue?vue&type=script&lang=js&"
export * from "./TextList.vue?vue&type=script&lang=js&"
import style0 from "./TextList.vue?vue&type=style&index=0&id=d4d54af6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d54af6",
  null
  
)

export default component.exports